// Auto-generated file. Do not edit manually.
export const NOTIFICATION_SETTINGS_KEYS = [
  'App\\Notifications\\DelayProvisioned',
  'App\\Notifications\\DelayTimeBarNotification',
  'App\\Notifications\\VariationOrderProvisioned',
  'App\\Notifications\\VariationOrderTimeBarNotification',
  'App\\Notifications\\ClaimStatusChangedNotification',
  'App\\Notifications\\ClaimTimeBarNotification',
  'App\\Notifications\\MonthlyClaimDueSoonNotification',
  'App\\Notifications\\BoqLockStatusNotification',
  'App\\Notifications\\ProjectArchiveStatusNotification',
  'App\\Notifications\\DiaryEntryRequiresReviewNotification',
  'App\\Notifications\\MonthlyReportsGeneratedNotification',
  'App\\Notifications\\ContractEventNotification',
] as const;

export const NOTIFICATION_SETTINGS_LABELS = {
  'App\\Notifications\\DelayProvisioned': 'Delay Provisioned Notification',
  'App\\Notifications\\DelayTimeBarNotification': 'Delay Time Bar Notification',
  'App\\Notifications\\VariationOrderProvisioned': 'Variation Order Provisioned Notification',
  'App\\Notifications\\VariationOrderTimeBarNotification': 'Variation Order Time Bar Notification',
  'App\\Notifications\\ClaimStatusChangedNotification': 'Claim Status Changed Notification',
  'App\\Notifications\\ClaimTimeBarNotification': 'Claim Time Bar Notification',
  'App\\Notifications\\MonthlyClaimDueSoonNotification': 'Monthly Claim Due Soon Notification',
  'App\\Notifications\\BoqLockStatusNotification': 'BOQ Lock Status Notification',
  'App\\Notifications\\ProjectArchiveStatusNotification': 'Project Archive Status Notification',
  'App\\Notifications\\DiaryEntryRequiresReviewNotification': 'Diary Entry Requires Review Notification',
  'App\\Notifications\\MonthlyReportsGeneratedNotification': 'Monthly Reports Generated Notification',
  'App\\Notifications\\ContractEventNotification': 'Contract Event Notification',
} as const;

export type NotificationSettingKey = typeof NOTIFICATION_SETTINGS_KEYS[number];

export type NotificationSettings = {
  'App\\Notifications\\DelayProvisioned'?: boolean | number[];
  'App\\Notifications\\DelayTimeBarNotification'?: boolean | number[];
  'App\\Notifications\\VariationOrderProvisioned'?: boolean | number[];
  'App\\Notifications\\VariationOrderTimeBarNotification'?: boolean | number[];
  'App\\Notifications\\ClaimStatusChangedNotification'?: boolean | number[];
  'App\\Notifications\\ClaimTimeBarNotification'?: boolean | number[];
  'App\\Notifications\\MonthlyClaimDueSoonNotification'?: boolean | number[];
  'App\\Notifications\\BoqLockStatusNotification'?: boolean | number[];
  'App\\Notifications\\ProjectArchiveStatusNotification'?: boolean | number[];
  'App\\Notifications\\DiaryEntryRequiresReviewNotification'?: boolean | number[];
  'App\\Notifications\\MonthlyReportsGeneratedNotification'?: boolean | number[];
  'App\\Notifications\\ContractEventNotification'?: boolean | number[];
};
